import React from "react";
import "../style/footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Brand */}
        <div className="footer-section">
          <h2 className="logo">AutoPark</h2>
          <p>
            Premium cars, unmatched experience. We help you find your dream car
            with confidence and ease.
          </p>
        </div>

        {/* Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p>Email: autopark.lennestadt@gmail.com</p>
          <p>Phone: +49 175 1932947</p>
          <p>Location: Lennestadt, Germany</p>
        </div>

        

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} AutoPark. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;